<template>
  <div class="jyxxschool">
    <div class="ffftitle">学校就业查询</div>

    <div class="box">
      <!-- 上半部分：下拉框和搜索框 -->
      <div class="shaixuan">
        <div>
          <!-- 院校名称筛选 -->
          <el-input
            v-model="yxmc"
            placeholder="请输入院校名称"
            class="handle-input mr10"
            style="width: 270px; padding-right: 20px"
            @keyup.native.enter="getAllJyxxSchool"
          ></el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getAllJyxxSchool"
            >搜索</el-button
          >
        </div>
      </div>

      <el-divider></el-divider>

      <div>
        <!-- 院校所在地筛选 -->
        <el-select
          style="width: 180px; padding-right: 20px"
          v-model="yxszd"
          placeholder="请选择院校所在地"
          @change="getAllJyxxSchool"
        >
          <el-option
            v-for="item in options1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <!-- 主管部门类别筛选 -->
        <el-select
          style="width: 180px; padding-right: 20px"
          v-model="zgbmlb"
          placeholder="请选择主管部门类别"
          @change="getAllJyxxSchool"
        >
          <el-option
            v-for="item in options2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <!-- 院校类型筛选 -->
        <el-select
          style="width: 180px; padding-right: 20px"
          v-model="yxlx"
          placeholder="请选择院校类型"
          @change="getAllJyxxSchool"
        >
          <el-option
            v-for="item in options3"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <!-- 学历层次筛选 -->
        <el-select
          style="width: 180px; padding-right: 20px"
          v-model="schoolType"
          placeholder="请选择学历层次"
          @change="getAllJyxxSchool"
        >
          <el-option
            v-for="item in options4"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <!-- 年份筛选 -->
        <el-select
          style="width: 180px; padding-right: 20px"
          v-model="year"
          placeholder="请选择年份"
          @change="getAllJyxxSchool"
        >
          <el-option
            v-for="item in options5"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <el-divider></el-divider>

      <!-- 下半部分：表格 -->
      <div class="table">
        <el-table
          :data="tableData"
          style="width: 100%; border: 2px solid #f0f6f9"
          :header-cell-style="{
            color: 'black',
            fontSize: '15px',
            fontFamily: 'MicrosoftYaHeiUI',
          }"
          :row-style="{ fontSize: '14px', fontFamily: 'MicrosoftYaHeiUI' }"
        >
          <!-- 第一列院校名称-->
          <el-table-column label="院校名称" width="200px" align="center">
            <!-- 实现跳转 -->
            <template slot-scope="scope">
              <!-- <router-link
              :to="{ path: '/Trend', query: { id: scope.row.id } }"
              >{{ scope.row.yxmc }}</router-link
            > -->
              <span @click="quanBu(scope.row)" class="tips">{{
                scope.row.yxmc
              }}</span>
            </template>
          </el-table-column>
          <!-- 第二列-->
          <el-table-column
            prop="yxszd"
            label="院校所在地"
            width="100px"
            align="center"
          >
          </el-table-column>
          <!-- 第三列-->
          <el-table-column
            prop="zgbmlb"
            label="教育行政主管部门"
            width="160px"
            align="center"
          >
          </el-table-column>
          <!-- 第四列-->
          <el-table-column
            prop="yxlx"
            label="院校类型"
            width="100px"
            align="center"
          >
          </el-table-column>
          <!-- 第五列-->
          <el-table-column
            prop="schoolType"
            label="学历层次"
            width="140px"
            align="center"
          >
          </el-table-column>
          <!-- 第6列-->
          <el-table-column prop="year" label="年份" width="90px" align="center">
          </el-table-column>
          <!-- 第7列-->
          <el-table-column label="本科毕业生人数" width="130px" align="center">
            <!-- 实现跳转和人数非0判断 -->
            <template slot-scope="scope">
              <span v-if="scope.row.bbyss != 0">
                <!-- <router-link
                :to="{ path: '/BJobChoice', query: { id: scope.row.id } }"
                >{{ scope.row.bbyss }}</router-link
              > -->
                <span @click="benKe(scope.row)" class="tips">{{
                  scope.row.bbyss
                }}</span>
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- 第8列-->
          <el-table-column label="专科毕业生人数" width="130px" align="center">
            <!-- 实现跳转和人数非0判断 -->
            <template slot-scope="scope">
              <span v-if="scope.row.zbyss != 0">
                <!-- <router-link
                :to="{ path: '/ZJobChoice', query: { id: scope.row.id } }"
                >{{ scope.row.zbyss }}</router-link
              > -->
                <span @click="zhuanKe(scope.row)" class="tips">{{
                  scope.row.zbyss
                }}</span>
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- 第9列-->
          <el-table-column prop="joinwork" label="就业质量报告" align="center">
            <template slot-scope="scope">
              <span @click="view(scope.row)">
                <el-button type="primary" icon="el-icon-view" round size="small"
                  >预览</el-button
                >
              </span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block">
          <el-pagination
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
            :current-page.sync="pageIndex"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="pageSize"
            layout="total,sizes, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>

      <!-- 弹窗 -->
      <div>
        <!-- 专科弹窗 -->
        <el-dialog :visible.sync="dialogTableVisible1">
          <z-job-choice :idzk="idzk"></z-job-choice>
        </el-dialog>

        <!-- 本科弹窗 -->
        <el-dialog :visible.sync="dialogTableVisible2">
          <b-job-choice :idbk="idbk"></b-job-choice
        ></el-dialog>

        <!-- 总体趋势弹窗 -->
        <el-dialog
          width="60%"
          :visible.sync="dialogTableVisible3"
          @opened="open()"
        >
          <div>
            <div class="title">{{ tcyxmc }}毕业生信息</div>
            <div>
              <div
                id="myChart1"
                :style="{ width: '900px', height: '600px' }"
              ></div>
              <div
                id="myChart2"
                :style="{ width: '900px', height: '600px' }"
              ></div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import school from "../../api/forecast";
import BJobChoice from "./BJobChoice.vue";
// import Trend from "./Trend.vue";
import ZJobChoice from "./ZJobChoice.vue";
export default {
  data() {
    return {
      //分页参数
      pageIndex: 1,
      pageSize: 20,
      total: 100,

      //条件参数
      //院校名称
      yxmc: "",
      //院校所在地
      options1: [
        {
          value: "",
          label: "院校所在地（全部）",
        },
        {
          value: "北京",
          label: "北京",
        },
        {
          value: "天津",
          label: "天津",
        },
        {
          value: "河北",
          label: "河北",
        },
        {
          value: "山西",
          label: "山西",
        },
        {
          value: "内蒙古",
          label: "内蒙古",
        },
        {
          value: "辽宁",
          label: "辽宁",
        },
        {
          value: "吉林",
          label: "吉林",
        },
        {
          value: "黑龙江",
          label: "黑龙江",
        },
        {
          value: "上海",
          label: "上海",
        },
        {
          value: "江苏",
          label: "江苏",
        },
        {
          value: "浙江",
          label: "浙江",
        },
        {
          value: "安徽",
          label: "安徽",
        },
        {
          value: "福建",
          label: "福建",
        },
        {
          value: "江西",
          label: "江西",
        },
        {
          value: "山东",
          label: "山东",
        },
        {
          value: "河南",
          label: "河南",
        },
        {
          value: "湖北",
          label: "湖北",
        },
        {
          value: "广东",
          label: "广东",
        },
        {
          value: "广西",
          label: "广西",
        },
        {
          value: "海南",
          label: "海南",
        },
        {
          value: "重庆",
          label: "重庆",
        },
        {
          value: "贵州",
          label: "贵州",
        },
        {
          value: "四川",
          label: "四川",
        },
        {
          value: "云南",
          label: "云南",
        },
        {
          value: "西藏",
          label: "西藏",
        },
        {
          value: "陕西",
          label: "陕西",
        },
        {
          value: "甘肃",
          label: "甘肃",
        },
        {
          value: "青海",
          label: "青海",
        },
        {
          value: "宁夏",
          label: "宁夏",
        },
        {
          value: "新疆",
          label: "新疆",
        },
      ],
      yxszd: "",

      //主管部门类别
      options2: [
        {
          value: "",
          label: "主管部门类别（全部）",
        },
        {
          value: "教育部",
          label: "教育部",
        },
        {
          value: "地方",
          label: "地方",
        },
        {
          value: "军校",
          label: "军校",
        },
        {
          value: "其他部委",
          label: "其他部委",
        },
      ],
      zgbmlb: "",

      //院校类型
      options3: [
        {
          value: "",
          label: "院校类型（全部）",
        },
        {
          value: "综合",
          label: "综合",
        },
        {
          value: "工科",
          label: "工科",
        },
        {
          value: "农业",
          label: "农业",
        },
        {
          value: "林业",
          label: "林业",
        },
        {
          value: "医药",
          label: "医药",
        },
        {
          value: "师范",
          label: "师范",
        },
        {
          value: "语言",
          label: "语言",
        },
        {
          value: "财经",
          label: "财经",
        },
        {
          value: "政法",
          label: "政法",
        },
        {
          value: "体育",
          label: "体育",
        },
        {
          value: "艺术",
          label: "艺术",
        },
        {
          value: "民族",
          label: "民族",
        },
      ],
      yxlx: "",

      //学历层次
      options4: [
        {
          value: "",
          label: "学历层次（全部）",
        },
        {
          value: "本科",
          label: "本科",
        },
        {
          value: "高职(专科)",
          label: "高职(专科)",
        },
        {
          value: "本科/高职(专科)",
          label: "本科/高职(专科)",
        },
      ],
      schoolType: "",

      //年份
      options5: [
        {
          value: "",
          label: "年份（全部）",
        },
        {
          value: "2010",
          label: "2010",
        },
        {
          value: "2011",
          label: "2011",
        },
        {
          value: "2012",
          label: "2012",
        },
        {
          value: "2013",
          label: "2013",
        },
        {
          value: "2014",
          label: "2014",
        },
        {
          value: "2015",
          label: "2015",
        },
        {
          value: "2016",
          label: "2016",
        },
        {
          value: "2017",
          label: "2017",
        },
        {
          value: "2018",
          label: "2018",
        },
        {
          value: "2019",
          label: "2019",
        },
        {
          value: "2020",
          label: "2020",
        },
      ],
      year: "",

      // flag: "true",
      tableData: [],

      //组件传值
      idxx: 666,
      idbk: 123,

      //弹窗
      dialogTableVisible1: false,
      dialogTableVisible2: false,
      dialogTableVisible3: false,

      //趋势弹窗数据
      id: 1625,
      tcyxmc: "",
      ListData: [],

      //图表一参数
      YearData: [],
      NanData: [],
      NvData: [],
      ZData: [],

      //图表数据1
      option1: {
        title: {
          text: "毕业生男女比例",
          textStyle: {
            color: "#130c0e",
          },
          // subtext: "毕业生男女比例",
          // subtextStyle: {
          //   color: "#130c0e",
          // },
          // padding: [0, 0, 10, 100], // 位置
        },
        legend: {
          // data:this.b,
          data: ["男", "女", "总人数"],
          orient: "horizontal", //垂直显示
          // y: "top", //延Y轴居中
          // x: "right" //居右显示
          right: 100, //右邊距
          top: 5, // 上邊距
        },
        yAxis: {
          data: ["2017", "2018", "2019", "2020"],
        },
        xAxis: {},
        series: [
          {
            label: {
              normal: {
                show: true,
                position: "inside",
              },
            },
            data: [10, 22, 28, 43],
            name: "男",
            color: "#63b2ee ",
            type: "bar",
            stack: "x",
          },
          {
            label: {
              normal: {
                show: true,
                position: "inside",
              },
            },
            data: [5, 4, 3, 5],
            name: "女",
            color: "#76da91 ",
            type: "bar",
            stack: "x",
          },
          {
            label: {
              normal: {
                show: true,
                position: "inside",
              },
            },
            data: [2, 6, 15, 10],
            name: "总人数",
            color: "#f8cb7f ",
            type: "bar",
            stack: "x",
          },
        ],
      },

      //图表二参数
      SxData: [],
      WjyData: [],
      LhjyData: [],
      CyData: [],
      XyhhtjyData: [],

      //图表数据2
      option2: {
        title: {
          text: "毕业生就业去向",
          textStyle: {
            color: "#130c0e",
          },
          // subtext: "毕业生就业去向",
          // subtextStyle: {
          //   color: "#130c0e",
          // },
          // padding: [0, 0, 10, 100], // 位置
        },
        legend: {
          // data:this.b,
          data: ["升学", "未就业", "灵活就业", "创业", "协议合同就业"],
          orient: "horizontal", //垂直显示
          // y: "top", //延Y轴居中
          // x: "right" //居右显示
          right: 100, //右邊距
          top: 5, // 上邊距
        },
        yAxis: {
          data: ["2017", "2018", "2019", "2020"],
        },
        xAxis: {},
        series: [
          {
            label: {
              normal: {
                show: true,
                position: "inside",
              },
            },
            data: [10, 22, 28, 43],
            name: "升学",
            color: "#63b2ee  ",
            type: "bar",
            stack: "x",
          },
          {
            label: {
              normal: {
                show: true,
                position: "inside",
              },
            },
            data: [5, 4, 3, 5],
            name: "未就业",
            color: "#76da91   ",
            type: "bar",
            stack: "x",
          },
          {
            label: {
              normal: {
                show: true,
                position: "inside",
              },
            },
            data: [2, 6, 15, 10],
            name: "灵活就业",
            color: "#f8cb7f   ",
            type: "bar",
            stack: "x",
          },
          {
            label: {
              normal: {
                show: true,
                position: "inside",
              },
            },
            data: [2, 6, 15, 10],
            name: "创业",
            color: "#f89588    ",
            type: "bar",
            stack: "x",
          },
          {
            label: {
              normal: {
                show: true,
                position: "inside",
              },
            },
            data: [2, 6, 15, 10],
            name: "协议合同就业",
            color: "#7cd6cf   ",
            type: "bar",
            stack: "x",
          },
        ],
      },
    };
  },
  methods: {
    //获取所有学校信息
    getAllJyxxSchool() {
      let params = {
        current: this.pageIndex,
        size: this.pageSize,
        yxmc: this.yxmc,
        yxszd: this.yxszd,
        zgbmlb: this.zgbmlb,
        yxlx: this.yxlx,
        schoolType: this.schoolType,
        year: this.year,
      };
      school.getAllJyxxSchool(params).then((res) => {
        this.tableData = res.list;
        //console.log(this.tableData);
        this.total = res.total;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getAllJyxxSchool();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getAllJyxxSchool();
    },
    //专科弹窗点击事件
    zhuanKe(row) {
      this.idzk = row.id;
      this.dialogTableVisible1 = true;
    },
    //本科弹窗点击事件
    benKe(row) {
      this.idbk = row.id;
      this.dialogTableVisible2 = true;
    },
    //所有信息弹窗点击事件
    quanBu(row) {
      this.id = row.id;
      this.dialogTableVisible3 = true;
    },

    //调用接口获取数据
    getYearById() {
      school.getYearById(this.id).then((res) => {
        // console.log(res);
        this.ListData = res.data;
        // console.log(this.ListData);
        this.tcyxmc = this.ListData[0].yxmc;

        //毕业生男女比例数据渲染
        for (var i = 0; i < this.ListData.length; i++) {
          this.YearData[i] = this.ListData[i].year;
        }
        for (var i = 0; i < this.ListData.length; i++) {
          this.NanData[i] = this.ListData[i].bboys + this.ListData[i].zboys;
        }
        for (var i = 0; i < this.ListData.length; i++) {
          this.NvData[i] = this.ListData[i].bgirls + this.ListData[i].zgirls;
        }
        for (var i = 0; i < this.ListData.length; i++) {
          this.ZData[i] = this.ListData[i].bbyss + this.ListData[i].zbyss;
        }

        this.option1.yAxis.data = this.YearData;
        this.option1.series[0].data = this.NanData;
        this.option1.series[1].data = this.NvData;
        this.option1.series[2].data = this.ZData;
        // console.log(this.option3.series[2].data);

        //毕业生就业去向数据渲染
        for (var i = 0; i < this.ListData.length; i++) {
          this.SxData[i] = this.ListData[i].bsx + this.ListData[i].zsx;
        }
        for (var i = 0; i < this.ListData.length; i++) {
          this.WjyData[i] = this.ListData[i].bwjy + this.ListData[i].zwjy;
        }
        for (var i = 0; i < this.ListData.length; i++) {
          this.LhjyData[i] = this.ListData[i].blhjy + this.ListData[i].zlhjy;
        }
        for (var i = 0; i < this.ListData.length; i++) {
          this.CyData[i] = this.ListData[i].bcy + this.ListData[i].zcy;
        }
        for (var i = 0; i < this.ListData.length; i++) {
          this.XyhhtjyData[i] =
            this.ListData[i].bxyhhtjy + this.ListData[i].zxyhhtjy;
        }
        this.option2.yAxis.data = this.YearData;
        this.option2.series[0].data = this.SxData;
        this.option2.series[1].data = this.WjyData;
        this.option2.series[2].data = this.LhjyData;
        this.option2.series[3].data = this.CyData;
        this.option2.series[4].data = this.XyhhtjyData;
      });
    },

    //毕业生男女比例柱状图
    drawGender1() {
      // 基于准备好的dom，初始化echarts实例
      let myChart1 = this.$echarts.init(document.getElementById("myChart1"));
      //准备数据
      // 绘制图表
      myChart1.setOption(this.option1);
    },

    //毕业生就业去向柱状图
    drawEmployment1() {
      // 基于准备好的dom，初始化echarts实例
      let myChart2 = this.$echarts.init(document.getElementById("myChart2"));
      //准备数据
      // 绘制图表
      myChart2.setOption(this.option2);
    },

    //pdf预览点击事件
    view(row) {
      const { href } = this.$router.resolve({
        path: "/pdf",
        query: {
          fileName: row.yxmc,
          year: row.year,
        },
      });
      window.open(href, "_blank");
    },

    open() {
      this.getYearById();
      this.drawGender1();
      this.drawEmployment1();
    },
  },

  mounted() {},

  //监听事件
  watch: {
    option1: {
      handler(newName, oldName) {
        if (newName) {
          this.drawGender1();
        }
      },
      deep: true,
    },

    option2: {
      handler(newName, oldName) {
        if (newName) {
          this.drawEmployment1();
        }
      },
      deep: true,
    },

    id: {
      handler(newName, oldName) {
        if (newName) {
          this.getYearById();
        }
      },
      deep: true,
    },
  },

  created() {
    this.getAllJyxxSchool();
  },
  components: {
    ZJobChoice,
    BJobChoice,
  },
};
</script>

<style scoped>
.el-pagination {
  text-align: right;
}

.block {
  margin-top: 12px;
}
.tips:hover {
  cursor: pointer;
  color: rgb(16, 235, 16);
}
.title {
  line-height: 60px;
  font-weight: 400;
  font-size: 30px;
  padding: 20px 0;
  padding-top: 0;
  text-align: center;
}
.ffftitle {
  width: 100%;
  height: 80px;
  background-image: url(../../assets/img/query01.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 -100px;
  text-align: center;
  line-height: 80px;
  font-size: 32px;
  color: #fff;
  letter-spacing: 20px;
  opacity: 0.8;
}
.el-col {
  height: 500px;
}
.jyxxschool {
  height: 100vh;
  overflow: auto;
}

.box {
  width: 80%;
  margin: auto;
}

.shaixuan {
  padding-top: 25px;
}
</style>